import React, { useState } from "react";
import { IClientAccount } from '../../interface/IClientAccount.ts';
import { IOption } from "../../interface/IOption.ts";
import { useHelper } from "../../features/functions/helper.tsx";
import Button from "../Form/Button.tsx";
import FileInput from "../Form/FileInput.tsx";
import { useClientAccountApi } from "../../features/auth/hooks/use-client-account-api.ts";
import { ApiResponseType } from "../../features/api/types.ts";

const SingleAccountPreview = ({
    clientAccount,
    clientAccountTypePrivate,
    clientAccountTypeCompany,
    directDebitPayment,
    transferPayment,
    outerUpdateHandler,
}: {
    clientAccount:IClientAccount,
    clientAccountTypePrivate: IOption,
    clientAccountTypeCompany: IOption,
    directDebitPayment: IOption,
    transferPayment: IOption,
    outerUpdateHandler: Function
}) => {

    const [thisClientAccount, setThisClientAccount] = useState<IClientAccount>(clientAccount);

    const { formatDateFromTimestamp } = useHelper();
    const { postClientAccountDebitAuthorization, getClientAccountDebitAuthorizationTemplate } = useClientAccountApi();
    const allowedFileTypes = ['application/pdf'];
    const [fileUploadErrors, setFileUploadErrors] = useState<String>('');
    const [uploadLoading, setUploadLoading] = useState<boolean>(false);

    let isFilledByFPSB = false;
    if (
        clientAccount.client_account_cost_position ||
        clientAccount.client_account_budget_number ||
        clientAccount.client_account_project_number ||
        clientAccount.client_account_ust_id
    ) {
        isFilledByFPSB = true;
    }

    const downloadMandatPDF = () => {
        getClientAccountDebitAuthorizationTemplate().then(res => {
            if (res.type === ApiResponseType.OK) {
                let base64String = 'data:' + res.payload.content_type + ';base64,' + res.payload.payload;
                var a = document.createElement("a");
                a.href = base64String
                a.download = "SEPA-Mandat.pdf";
                a.click();
            }
        })
    }

    const handleFileChange = (file:File) => {
        
        let fileName = file.name;
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            let result = reader.result;
            if (result) {
                let clientAccountClone = structuredClone(thisClientAccount);
                clientAccountClone.payload = String(result).split(',')[1];
                clientAccountClone.filename = fileName;
                setThisClientAccount(clientAccountClone);
            }
        }, false);
        reader.readAsDataURL(file);
    }

    const uploadToClientAccount = () => {
        setUploadLoading(true);
        postClientAccountDebitAuthorization(thisClientAccount, {
            filename: thisClientAccount.filename,
            payload: thisClientAccount.payload
        }).then(res => {
            setUploadLoading(false);
            if (res.type === ApiResponseType.OK) {
                let clientAccountClone = structuredClone(thisClientAccount);
                clientAccountClone.is_sepa_document_uploaded = '1';
                outerUpdateHandler(thisClientAccount);
                setThisClientAccount(clientAccountClone);
            }
        })
    }
    
    return (
        <>
            <div className="row account-preview">
                <div className="col-6">
                    <h5 className="mb-2">Rechnungsadresse</h5>
                    { thisClientAccount.client_account_billing_name && (<p>{ thisClientAccount.client_account_billing_name }</p>)}
                    { thisClientAccount.client_account_department && (<p>{ thisClientAccount.client_account_department }</p>)}
                    { thisClientAccount.client_account_contact_person && (<p>{ thisClientAccount.client_account_contact_person }</p>) }
                    <br />
                    <div className="adress-block">
                        { thisClientAccount.client_account_address && (<p>{ thisClientAccount.client_account_address }</p>)}
                        { thisClientAccount.client_account_address_extra && (<p>{ thisClientAccount.client_account_address_extra }</p>)}
                        { (thisClientAccount.client_account_zip || thisClientAccount.client_account_city) && (<p>{ thisClientAccount.client_account_zip } { thisClientAccount.client_account_city }</p>)}
                        { thisClientAccount.client_account_country && (<p>{ thisClientAccount.client_account_country.label }</p>)}
                    </div>
                    <br />
                    { thisClientAccount.client_account_email && (<p>Rechnungsversand an: { thisClientAccount.client_account_email }</p>)}
                    <br />
                    { isFilledByFPSB && thisClientAccount.client_account_type === clientAccountTypeCompany.id && (
                        (thisClientAccount.client_account_cost_position && thisClientAccount.client_account_cost_position.length > 0) ||
                        (thisClientAccount.client_account_budget_number && thisClientAccount.client_account_budget_number.length > 0) ||
                        (thisClientAccount.client_account_project_number && thisClientAccount.client_account_project_number.length > 0) ||
                        (thisClientAccount.client_account_ust_id && thisClientAccount.client_account_ust_id.length > 0)
                    ) && (
                        <>
                            <p><strong>Zusätzliche Informationen für <u>geschäftliche</u> Rechnungsdaten</strong></p>
                            { thisClientAccount.client_account_cost_position && (<p>Kostenstelle: { thisClientAccount.client_account_cost_position }</p>) }
                            { thisClientAccount.client_account_budget_number && (<p>Budgetnummer: { thisClientAccount.client_account_budget_number }</p>) }
                            { thisClientAccount.client_account_project_number && (<p>Projektnummer: { thisClientAccount.client_account_project_number }</p>) }
                            { thisClientAccount.client_account_ust_id && (<p>UST-ID / VAT: { thisClientAccount.client_account_ust_id }</p>) }
                        </>
                    ) }
                </div>
                <div className="col-6">
                    <h5 className="mb-2">Zahlungsmethode</h5>
                    { thisClientAccount.client_account_payment_type === directDebitPayment.id && (
                        <>
                            { thisClientAccount.bank_account_owner && (<p>Kontoinhaber: { thisClientAccount.bank_account_owner }</p>)}
                            { thisClientAccount.bank_account_iban && (<p>IBAN: { thisClientAccount.bank_account_iban }</p>)}
                            { thisClientAccount.bank_account_bic && (<p>BIC: { thisClientAccount.bank_account_bic }</p>)}
                            { thisClientAccount.bank_account_name && (<p>Kreditinstitut: { thisClientAccount.bank_account_name }</p>)}
                            { (thisClientAccount.client_account_type === clientAccountTypeCompany.id) && (
                                <>
                                    {
                                        !thisClientAccount.bank_account_company_debit_authorized && thisClientAccount.is_sepa_document_uploaded !== '1' ? (
                                            <>
                                                <span className="message mt-1">Einzugsermächtigung nicht vorhanden.</span>    
                                                <div className="account-upload-sepa-area">
                                                    <p>Bei geschäftlichen Rechnungskonten ist die Zustimmung des Kontoinhabers zum SEPA-Lastschriftmandat notwendig.  Bitte laden Sie die PDF-beschreibbare Mandatsvorlage zur Vervollständigung herunter, lassen diese vom Kontoinhaber unterschreiben und laden sie anschließend wieder hoch.</p>
                                                    <Button
                                                        type='button'
                                                        buttonType="primary"
                                                        icon="download"
                                                        onClick={downloadMandatPDF}
                                                    >Jetzt Mandatsvorlage herunterladen</Button>
                                                    <FileInput
                                                        label="SEPA-Lastschriftmandat hochladen"
                                                        name={'payload-' + thisClientAccount.id}
                                                        onChange={(event) => {
                                                            const [file] = event.target.files;
                                                            if (allowedFileTypes.includes(file.type)) {
                                                                if (file) {
                                                                    handleFileChange(file);
                                                                }
                                                            } else {
                                                                setFileUploadErrors('Dateiart nicht erlaubt');
                                                            }
                                                        }}
                                                        accept={allowedFileTypes.join(', ')}
                                                    />
                                                    { thisClientAccount.filename && (
                                                        <div className="mt-3">
                                                            <p>Die Datei wird durch Speichern des Formulars hochgeladen. Es erfolgt eine Prüfung und Erfassung durch den FPSB Deutschland. Sie erhalten eine E-Mail, wenn der Prozess abgeschlossen ist.</p>
                                                            <div className="row align-items-center">
                                                                <span className="message m-0">Gewählte Datei: {thisClientAccount.filename}</span>
                                                                { uploadLoading ? (
                                                                    <div className="loader"></div>
                                                                ) : (
                                                                    <Button
                                                                        type='button'
                                                                        buttonType="primary"
                                                                        icon="upload"
                                                                        wrapperClassName="m-0"
                                                                        onClick={uploadToClientAccount}
                                                                    >Speichern</Button>
                                                                ) }
                                                            </div>
                                                        </div>
                                                    ) } 
                                                    { fileUploadErrors && (
                                                        <span className="message error">{fileUploadErrors}</span>
                                                    )}
                                                </div>                                
                                            </>
                                        ) : ''
                                    }
                                    {
                                        !thisClientAccount.bank_account_company_debit_authorized && thisClientAccount.is_sepa_document_uploaded === '1' ? (
                                            <>
                                                <span className="message mt-1">Einzugsermächtigung wurde hochgeladen.</span> 
                                                <p>Die Daten aus dem SEPA-Lastschriftmandat werden zeitnah von der FPSB Geschäftsstelle erfasst.</p>
                                            </>
                                        ) : ''
                                    }
                                    {
                                        thisClientAccount.bank_account_company_debit_authorized && thisClientAccount.is_sepa_document_uploaded === '1' ? (
                                            <>
                                                <span className="message mt-2">Mandat erteilt am: {formatDateFromTimestamp(thisClientAccount.bank_account_company_debit_authorized)}</span>
                                                { thisClientAccount.client_account_mandate_valid_from ? (
                                                    <p className="mb">Mandat gültig ab: {formatDateFromTimestamp(thisClientAccount.client_account_mandate_valid_from)}</p>
                                                ) : '' }
                                                { !thisClientAccount.bank_account_company_debit_authorized && thisClientAccount.is_sepa_document_uploaded === '1' ? (
                                                    <p className="mb">Die Daten aus dem SEPA-Lastschriftmandat werden zeitnah von der FPSB Geschäftsstelle erfasst.</p>
                                                ) : '' }
                                            </>
                                        ) : ''
                                    }
                                </>
                            )}
                            { thisClientAccount.client_account_type === clientAccountTypePrivate.id && (
                                thisClientAccount.bank_account_debit_authorization ? (
                                    <>
                                        <span className="message mt-2">Einzugsermächtigung erteilt.</span>
                                        { thisClientAccount.client_account_mandate_valid_from ? (
                                            <p className="mb">Mandat gültig ab: {formatDateFromTimestamp(thisClientAccount.client_account_mandate_valid_from)}</p>
                                        ) : '' }
                                    </>
                                ) : (
                                    <span className="message mt-2">Einzugsermächtigung nicht erteilt.</span>                            
                                )
                            ) }
                            { thisClientAccount.bank_account_sepa_mandate_reference && (<p>SEPA-Mandatsreferenz: { thisClientAccount.bank_account_sepa_mandate_reference }</p>)}
                            <p>Gläubiger-Identifikationsnummer: DE46ZZZ00000625761</p>
                        </>
                    ) }
                    { (thisClientAccount.client_account_payment_type === transferPayment.id) && (
                        <span className="message">Bezahlung per Überweisung.</span>
                    ) }
                    { thisClientAccount.client_account_payment_type !== directDebitPayment.id && thisClientAccount.client_account_payment_type !== transferPayment.id && (
                        <p>Bisher wurde keine Zahlungsmethode hinterlegt</p>
                    ) }
                </div>
            </div>
        </>
    )
}

export default SingleAccountPreview;